export default __webpack_public_path__ + "static/media/ss-activewear.eb7ca1a9.svg";